import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Admin from '@/pages/Admin'
import AdminLogin from '@/pages/AdminLogin'
import Success from '@/pages/Success'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/admin', element: <Admin /> },
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/success', element: <Success /> },
]

function App() {
  return useRoutes(routes)
}

export default App
